export default function MobileActivityList({ activities }) {
  return (
    <div className="mobileview d-none">
      <div className="parentbox">
        {activities.map((act, i) => (
          <div className="innerbox" key={i}>
            <div className="parentmain">
              <div className="left">
                <p>Date</p>
                <h6>
                  {act.date} <span>{act.time}</span>
                </h6>
              </div>
              <div className="left">
                <p>Activity</p>
                <h6>{act.type}</h6>
              </div>
            </div>
            <div className="parentmain">
              <div className="left">
                <p>Amount</p>
                <h6>{act.amount}</h6>
              </div>
              <div className="left">
                <p>TX Hash</p>
                <div className="traxxdiv">
                     <h6>
                  {act.txHash}
                </h6>
                <img src="\assets\tabshare.svg" />
                  </div>

              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
